var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./clojure.test.check.random.longs.bit_count_impl.js");
'use strict';$CLJS.qba=$CLJS.na;